const url = new URL(window.location)
let data = {}

export function setReferrers() {
  data = {
    comeFrom: document.referrer || null,
    adReferrer: url.searchParams.get('ad_referrer') || null,
    utm: getUTM()
  }
}

export function getReferrers() {
  return data
}

function getUTM() {
  let has = false
  let newQuery = {}

  url.searchParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      newQuery[key] = value
      has = true
    }
  })

  return has ? newQuery : null
}
